(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9e03"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9e03"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3wbXQ", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $28fda4159ae224de$export$6503ec6e8aabbaf; }, function (v) { return $28fda4159ae224de$export$6503ec6e8aabbaf = v; });
var $28fda4159ae224de$export$6503ec6e8aabbaf;
var $28fda4159ae224de$export$f7ad0328861e2f03;
"use strict";
var $28fda4159ae224de$var$mapping = new Map();
function $28fda4159ae224de$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$28fda4159ae224de$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $28fda4159ae224de$var$resolve(id) {
    var resolved = $28fda4159ae224de$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$28fda4159ae224de$export$6503ec6e8aabbaf = $28fda4159ae224de$var$register;
$28fda4159ae224de$export$f7ad0328861e2f03 = $28fda4159ae224de$var$resolve;

});

parcelRegister("jjhQE", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $e0eda2f25db6aa55$export$bdfd709ae4826697; }, function (v) { return $e0eda2f25db6aa55$export$bdfd709ae4826697 = v; });
var $e0eda2f25db6aa55$export$bdfd709ae4826697;
var $e0eda2f25db6aa55$export$c9e73fbda7da57b6;
var $e0eda2f25db6aa55$export$5a759dc7a1cfb72a;
"use strict";
var $e0eda2f25db6aa55$var$bundleURL = {};
function $e0eda2f25db6aa55$var$getBundleURLCached(id) {
    var value = $e0eda2f25db6aa55$var$bundleURL[id];
    if (!value) {
        value = $e0eda2f25db6aa55$var$getBundleURL();
        $e0eda2f25db6aa55$var$bundleURL[id] = value;
    }
    return value;
}
function $e0eda2f25db6aa55$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $e0eda2f25db6aa55$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $e0eda2f25db6aa55$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $e0eda2f25db6aa55$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$e0eda2f25db6aa55$export$bdfd709ae4826697 = $e0eda2f25db6aa55$var$getBundleURLCached;
$e0eda2f25db6aa55$export$c9e73fbda7da57b6 = $e0eda2f25db6aa55$var$getBaseURL;
$e0eda2f25db6aa55$export$5a759dc7a1cfb72a = $e0eda2f25db6aa55$var$getOrigin;

});

var $bb24426c9ca1567c$exports = {};


(parcelRequire("3wbXQ")).register((parcelRequire("jjhQE")).getBundleURL("bpn5L"), JSON.parse('["bpn5L","index.ad61af98.js","1W7eM","wireguard-logo.324e798b.png","4rWZW","user.513216f8.png","hPqIe","qr.b290a2ae.png","5MyvS","download.175f4a2f.png","COCET","delete.4ca64d03.png","1gM7v","plus.1d36d883.png"]'));

})();
//# sourceMappingURL=index.runtime.835a9caf.js.map
